const Home = () => {
    return (
        <div className="Home">
            <h1> TOOO lazy to make a home page </h1>
        </div>
    );
}

export default Home;
